import { isEmpty } from "../../../../../utils";
import { checkRes } from "../../config";

const checkHeaderOrder = (headerArr, fbHeader) => {
  if (isEmpty(headerArr)) return checkRes.failed;
  const check = headerArr.every((elStr, idx) => elStr === fbHeader[idx - 1].id);

  return check ? checkRes.success : checkRes.failed;
};

export default checkHeaderOrder;
